/** Long-press threshold before PTT arms on mobile (ms). */
export const FIREFLY_PTT_HOLD_MS = 300;

/** Desktop double-click window. A single click waits this long before toggling the panel. */
export const FIREFLY_DOUBLE_CLICK_MS = 300;

/** Max utterance length before auto-stop and submit (ms). */
export const FIREFLY_PTT_MAX_DURATION_MS = 15_000;

/** Desktop PTT hotkey chord: Ctrl+Shift+F (key matched case-insensitively). */
export const FIREFLY_PTT_HOTKEY_CTRL = true;
export const FIREFLY_PTT_HOTKEY_SHIFT = true;
export const FIREFLY_PTT_HOTKEY_KEY = "f";
